/**
 * Мост к форматеру дат.
 *
 * Даты и числа печатает пакет ui, и язык ему нужен тот же, что интерфейсу.
 * Зависимости между пакетами при этом нет: ui публикует setLocale, а сюда
 * приходит только ссылка на функцию. Приложение связывает их одной строкой в
 * своей точке входа.
 */
type Lang = 'ru' | 'en' | 'es';

let sink: ((lang: Lang) => void) | null = null;
let current: Lang = 'ru';

/** Кому сообщать о смене языка. Вызывается один раз при запуске приложения. */
export function onLocaleChange(fn: (lang: Lang) => void): void {
  sink = fn;
  fn(current);
}

export function setLocale(lang: Lang): void {
  current = lang;
  sink?.(lang);
}
